module.exports = __webpack_public_path__ + "media/images/games/cs-go/logo-1967cad9da1b3fb25fc1204819039277.png";